<template>
    <span>
        <b-btn variant="danger" @click="modal = true">
            Add Modifier Group
            <font-awesome-icon icon="plus" class="align-middle mx-1"/>
        </b-btn>
        <c-modal
            v-model="modal"
            cancel-label="Cancel"
            centered size="lg"
            title="Add New Modifier Group"
            :tag="false"
            label=""
            confirm-label="Submit"
            :progressing="loading || disableSend"
            @submit="submit"
        >
            <template>
                <b-container class="p-0" fluid>
                <b-row>
                    <b-col sm="6">
                        <label>Modifier Group Name</label>
                        <b-input-group>
                            <b-input v-model="CategoryComment" name="Modifier Group Name" v-validate="'required'"/>
                        </b-input-group>
                        <p class="mb-0 text-danger" v-if="duplicateNameText !== null">{{duplicateNameText}}</p>

                    </b-col>
                    <b-col sm="6">
                        <label>Applies to</label>
                        <b-input-group>
                            <b-select v-model="ModifierType" name="ModifierType" v-validate="'required'" :options="ModifierTypes"/>
                        </b-input-group>
                    </b-col>
                    <b-col sm="12" class="my-3">
                        <b-form-group label="Type : ">
                            <b-form-radio-group
                                    v-model="IsOptional"
                                    :options="IsOptionals"
                                    name="radio-inline"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <p class="font-weight-bold">
                            Define a rule for how many modifier options to choose
                        </p>
                    </b-col>
                    <b-col sm="12" md="6">
                        <label>Rule Type</label>
                        <b-input-group>
                            <b-select v-model="ChoiceOption"  name="Rule Type" v-validate="'required'" :options="ChoiceOptions"/>
                        </b-input-group>
                        <p v-if="disableSend" class="my-2 text-danger">Please define the rule type and rule number</p>
                    </b-col>
                    <b-col sm="12" md="6">
                        <label>Rule Number</label>
                        <b-input-group>
                            <b-input v-model="ChoiceNumber" name="Rule Number" v-validate="'required|min_value: 1'" type="number"/>
                        </b-input-group>
                    </b-col>
                    <b-col sm="12">
                        <b-alert :show="errors.any()" variant="danger" class="px-4 my-3">
                            <ul class="m-0 px-1">
                                <li v-for="err in errors.all()" :key="err">{{err}}</li>
                            </ul>
                        </b-alert>
                    </b-col>
                </b-row>
            </b-container>
            </template>
        </c-modal>
    </span>
</template>

<script>
    import CModal from "../shared/Cmodal";
    export default {
        name: "addModifierGroup",
        components: {CModal},
        data () {
            return {
                modal: false,
                ModifierTypes: [
                    { value: 'Food', text: 'Food' },
                    { value: 'Drink', text: 'Drink' },
                ],
                ModifierType: 'Food',
                IsOptional : 1,
                IsOptionals: [
                    { text: 'Optional', value: 1 },
                    { text: 'Required', value: 0 },
                ],
                ChoiceOptions: [
                    { text: 'Select Rule Type', value: null },
                    { text: 'Minimum', value: 'Minimum' },
                    { text: 'Maximum', value: 'Maximum' },
                    { text: 'Exactly', value: 'Exactly' },
                ],
                CategoryComment: null,
                ChoiceOption: null,
                ChoiceNumber: 1,
                loading: false,
                duplicateNameText: null,
                error: false
            }
        },
        computed: {
            disableSend () {
              if (this.IsOptional === 0 && this.ChoiceOption === 'None') {
                  return true
              } else {
                  return false
              }
            },
            validationRuleNumber () {
                if (this.IsOptional === 0) {
                    return {
                        required: true,
                        decimal: true,
                        min_value: 0
                    }
                } else if (this.ChoiceOption !== 'None') {
                    return {
                        required: true,
                        decimal: true,
                        min_value: 0
                    }
                } else {
                    return {
                        required: false,
                        decimal: true,
                        min_value: 0
                    }
                }
            }
        },

        methods: {
            submit () {
                this.getDupplicate().then(response => {
                    if (!response) {
                        //add modifier group
                        this.$validator.validateAll().then(res => {
                            if (res) {
                                this.duplicateNameText = null
                                let model = {
                                    // UserID: localStorage.getItem('userID'),
                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                    ModifierID: 0,
                                    CategoryDESC: this.CategoryComment,
                                    ChoiceNumber: this.ChoiceNumber,
                                    ChoiceOption: this.ChoiceOption,
                                    IsOptional: this.IsOptional,
                                    ModifierType: this.ModifierType,
                                }
                                this.loading = true

                                this.$api.getRestaurant.UpdateInsertCategoryModifier(model).then(res => {
                                    this.modal = false
                                    if (res.success) {
                                        this.loading = false
                                        let object = {
                                            id: res.message[1],
                                            CategoryComment: this.CategoryComment,
                                            ChoiceNumber: this.ChoiceNumber,
                                            ChoiceOption: this.ChoiceOption,
                                            IsOptional: this.IsOptional,
                                        }
                                        this.$emit('addCategory', object)
                                    } else {
                                        this.loading = false
                                        this.$showError(res.message)
                                    }
                                }).catch(() => {
                                    this.loading = false
                                })
                            }
                        })
                    } else {
                        this.duplicateNameText = 'This is a duplicate name'
                    }
                })

            },
            getDupplicate () {
                // check duplicate name of modifier group

                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    ModifierType: 'Food',
                    CategoryName: this.CategoryComment,
                    CategoryID: -1
                }
                return this.$api.getRestaurant.GetIsDuplicateModifierCategory(model).then(res => {
                    return res.results
                })
            }
        }
    }
</script>

<style scoped>

</style>
